import { useMemo } from 'react';
import { trpc } from '@/api/trpc';
import { DEFAULT_REQUISITIES_STALE_TIME } from '@/config/constants';
import { useAppQuery, type AppQueryErrorConfig } from './useAppQuery';

/**
 * Shared query for the user's trading profiles with the app-standard retry
 * and stale time. Mutations invalidate this query's key explicitly, so the
 * stale time is safe.
 */
export const useTradingProfiles = (options?: { enabled?: boolean; errorConfig?: AppQueryErrorConfig }) => {
    const query = useAppQuery(
        {
            ...trpc.user.fetchTradingProfiles.queryOptions(),
            enabled: options?.enabled,
            staleTime: DEFAULT_REQUISITIES_STALE_TIME
        },
        options?.errorConfig
    );

    const tradingProfiles = useMemo(() => query.data?.tradingProfiles ?? [], [query.data?.tradingProfiles]);

    return { error: query.error, isLoading: query.isLoading, query, tradingProfiles };
};
